import { List, Record } from 'immutable'
import { ISitePermission, SitePermission } from './SitePermission'

export interface IRole {
  readonly id: string
  readonly permissions: List<ISitePermission>
  readonly name: string
  readonly description: string
}

const RoleRecord = Record({
  description: '',
  id: '',
  name: '',
  permissions: List<SitePermission>(),
})

export class Role extends RoleRecord implements IRole {
  public static fromJS(initialState?: any) {
    if (!initialState) {
      return new Role()
    }

    const { permissions, ...rest } = initialState

    return new Role({
      permissions: permissions
        ? List(permissions.map((c: any) => SitePermission.fromJS(c)))
        : List<SitePermission>(),
      ...rest,
    })
  }

  public readonly id: string
  public readonly permissions: List<ISitePermission>
  public readonly name: string
  public readonly description: string

  constructor(props?: Partial<Role>) {
    props ? super(props) : super()
  }
}
